import { Trash2Icon, X } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Sidebar from "../../components/Sidebar";


function Panduan() {

  const [panduan, setPanduan] = useState([]);
  const [addPanduan, setAddPanduan] = useState(null);
  const [editId, setEditId] = useState(null);
  
  const [formDataPanduan, setFormDataPanduan] = useState({ title:'', step1:'', step2:'', step3:'', step4:'', step5:'', step6:'', step7:'', step8:'', step9:'', step10:'', image1:'', image2:'', image3:'', image4:'', image5:'', image6:'', image7:'', image8:'', image9:'', image10:''});

  const handleAdd = (event) => {
    setAddPanduan(event);
    setFormDataPanduan({ title:event.title, step1:event.step1, step2:event.step2, step3:event.step3, step4:event.step4, step5:event.step5, step6:event.step6, step7:event.step7, step8:event.step8, step9:event.step9, step10:event.step10, image1:event.image1, image2:event.image2, image3:event.image3, image4:event.image4, image5:event.image5, image6:event.image6, image7:event.image7, image8:event.image8, image9:event.image9, image10:event.image10 });
  };

  const fetchPanduan = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/panduan`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];

      setPanduan(list);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
  
  useEffect(() => {
    fetchPanduan();
  }, []);

  const handleEditClick = (item) => {
    setEditId(item.id);

    setFormDataPanduan({
      title: item.title,
      step1: item.step1,
      step2: item.step2,
      step3: item.step3,
      step4: item.step4,
      step5: item.step5,
      step6: item.step6,
      step7: item.step7,
      step8: item.step8,
      step9: item.step9,
      step10: item.step10,
      image1: null,
      image2: null,
      image3: null,
      image4: null,
      image5: null,
      image6: null,
      image7: null,
      image8: null,
      image9: null,
      image10: null,
    });

    setAddPanduan(true); // buka modal
  };

  const handleInsert = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", formDataPanduan.title);
      formData.append("step1", formDataPanduan.step1);
      formData.append("step2", formDataPanduan.step2);
      formData.append("step3", formDataPanduan.step3);
      formData.append("step4", formDataPanduan.step4);
      formData.append("step5", formDataPanduan.step5);
      formData.append("step6", formDataPanduan.step6);
      formData.append("step7", formDataPanduan.step7);
      formData.append("step8", formDataPanduan.step8);
      formData.append("step9", formDataPanduan.step9);
      formData.append("step10", formDataPanduan.step10);
      formData.append("image1", formDataPanduan.image1);
      formData.append("image2", formDataPanduan.image2);
      formData.append("image3", formDataPanduan.image3);
      formData.append("image4", formDataPanduan.image4);
      formData.append("image5", formDataPanduan.image5);
      formData.append("image6", formDataPanduan.image6);
      formData.append("image7", formDataPanduan.image7);
      formData.append("image8", formDataPanduan.image8);
      formData.append("image9", formDataPanduan.image9);
      formData.append("image10", formDataPanduan.image10);

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/panduan/insert`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {

        // Reset form
        setFormDataPanduan({
          title: "",
          step1: "",
          step2: "",
          step3: "",
          step4: "",
          step5: "",
          step6: "",
          step7: "",
          step8: "",
          step9: "",
          step10: "",
        });

        setAddPanduan(null);
        await fetchPanduan();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Panduan berhasil ditambahkan!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal menyimpan data");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };
  
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Yakin hapus Panduan ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/panduan/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire('Terhapus!', 'Panduan berhasil dihapus.', 'success');
            fetchPanduan();
          });
      }
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", formData.title);
      formData.append("step1", formData.step1);
      formData.append("step2", formData.step2);
      formData.append("step3", formData.step3);
      formData.append("step4", formData.step4);
      formData.append("step5", formData.step5);
      formData.append("step6", formData.step6);
      formData.append("step7", formData.step7);
      formData.append("step8", formData.step8);
      formData.append("step9", formData.step9);
      formData.append("step10", formData.step10);

      // hanya kirim icon jika ada file baru
      if (formData.image1) {
        formData.append("image1", formData.image1);
      }
      if (formData.image2) {
        formData.append("image2", formData.image2);
      }
      if (formData.image3) {
        formData.append("image3", formData.image3);
      }
      if (formData.image4) {
        formData.append("image4", formData.image4);
      }
      if (formData.image5) {
        formData.append("image5", formData.image5);
      }
      if (formData.image6) {
        formData.append("image6", formData.image6);
      }
      if (formData.image7) {
        formData.append("image7", formData.image7);
      }
      if (formData.image8) {
        formData.append("image8", formData.image8);
      }
      if (formData.image9) {
        formData.append("image9", formData.image9);
      }
      if (formData.image10) {
        formData.append("image10", formData.image10);
      }

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/panduan/update/${editId}`,
        {
          method: "POST", // CI4 biasanya POST untuk update
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok) {

        await fetchPanduan(); // refresh data
        
        setAddPanduan(null);
        await fetchPanduan();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Panduan berhasil diupdate!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal update");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };

  return (
    <div className="min-h-screen bg-white text-white">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 pt-40 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-about-us.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 opacity-100 translate-y-0
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-red-600  to-[#3E3274] bg-clip-text text-transparent">
            Halaman Admin
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-red-600  to-[#3E3274] mx-auto mb-6"></div>
        </div>
      </section>
      <section 
        data-section="contact"
        className="py-24 bg-white"
      >
        <div className='flex flex-row max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200'>
          <div className='w-1/4'>
            <Sidebar></Sidebar>
          </div>
          <div className='w-3/4 p-4 bg-gray-800 text-white flex-col md:relative md:flex rounded-3xl '>
            <div className='flex flex-col'>
              <div className='p-4 text-xl font-medium'>
                List Panduan Aplikasi
              </div>
              <div className='flex flex-row p-4'>
                <table class="min-w-full divide-y divide-gray-200 bg-gradient-to-b from-slate-900 to-slate-950 text-gray-400">
                  <thead class="font-bricolage font-bold mb-4 bg-gradient-to-r from-red-600  to-[#3E3274] text-transparent">
                    <tr>
                      <th class="p-4 font-medium text-white text-center">Title</th>
                      <th class="font-medium text-white text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200">
                    {Array.isArray(panduan) && panduan.map((a, idx) => (
                      <>
                        <tr class="hover:bg-gray-500">
                          <td class="p-4 text-white text-center">
                            {a.title}
                          </td>
                          <td class="p-4 text-white text-center">
                            <div className='flex flex-row gap-4 items-center justify-center'>
                              <FaTrash onClick={() => handleDelete(a.id)} className='cursor-pointer'></FaTrash>
                            </div>
                          </td>
                        </tr>
                      </>
                      ))
                    }
                  </tbody>
                </table>
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <button onClick={handleAdd} className='p-4 rounded-full bg-gradient-to-r from-red-600  to-[#3E3274] hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Tambah</button>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </section>
      {addPanduan && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4"
          onClick={() => {
            setAddPanduan(null);
            setEditId(null);
          }}
        >
          <div
            className="bg-white text-black p-6 rounded-2xl w-full max-w-4xl relative shadow-2xl max-h-[100vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-red-500 transition"
              onClick={() => {
                setAddPanduan(null);
                setEditId(null);
              }}
            >
              <X size={20} />
            </button>

            {/* Title */}
            <h3 className="text-xl font-bold mb-6 text-center">
              {editId
                ? "Edit Panduan"
                : "Tambah Panduan "}
            </h3>

            {/* Form */}
            <form
              onSubmit={editId ? handleUpdate : handleInsert}
              className="space-y-4"
            >
              <div>
                <label className="block font-medium mb-1">Title</label>
                <input
                  type="text"
                  value={formDataPanduan.title}
                  onChange={(e) =>
                    setFormDataPanduan({
                      ...formDataPanduan,
                      title: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  required
                />
              </div>
              <div className="flex flex-row gap-2">
                <div className="flex w-1/2">
                  <div className="flex flex-row gap-2">
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Langkah 1</label>
                        <input
                          type="text"
                          value={formDataPanduan.step1}
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              step1: e.target.value,
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                          required
                        />
                      </div>
                    </div>
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Gambar 1</label>
                        <input
                          type="file"
                          name="image1"
                          accept="*"
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              image1: e.target.files[0],
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg"
                        />
                      </div>
                    </div>
                  </div>    
                </div>
                <div className="flex w-1/2">
                  <div className="flex flex-row gap-2">
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Langkah 2</label>
                        <input
                          type="text"
                          value={formDataPanduan.step2}
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              step2: e.target.value,
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                          required
                        />
                      </div>
                    </div>
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Gambar 2</label>
                        <input
                          type="file"
                          name="image2"
                          accept="*"
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              image2: e.target.files[0],
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
              {/* Icon Upload */}
              
              <div className="flex flex-row gap-2">
                <div className="flex w-1/2">
                  <div className="flex flex-row gap-2">
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Langkah 3</label>
                        <input
                          type="text"
                          value={formDataPanduan.step3}
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              step3: e.target.value,
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                          required
                        />
                      </div>
                    </div>
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Gambar 3</label>
                        <input
                          type="file"
                          name="image3"
                          accept="*"
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              image3: e.target.files[0],
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex w-1/2">
                  <div className="flex flex-row gap-2">
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Langkah 4</label>
                        <input
                          type="text"
                          value={formDataPanduan.step4}
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              step4: e.target.value,
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                          
                        />
                      </div>
                    </div>
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Gambar 4</label>
                        <input
                          type="file"
                          name="image4"
                          accept="*"
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              image4: e.target.files[0],
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-row gap-2">
                <div className="flex w-1/2">
                  <div className="flex flex-row gap-2">
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Langkah 5</label>
                        <input
                          type="text"
                          value={formDataPanduan.step5}
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              step5: e.target.value,
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                          
                        />
                      </div>
                    </div>
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Gambar 5</label>
                        <input
                          type="file"
                          name="image5"
                          accept="*"
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              image5: e.target.files[0],
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex w-1/2">
                  <div className="flex flex-row gap-2">
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Langkah 6</label>
                        <input
                          type="text"
                          value={formDataPanduan.step6}
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              step6: e.target.value,
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                          
                        />
                      </div>
                    </div>
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Gambar 6</label>
                        <input
                          type="file"
                          name="image6"
                          accept="*"
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              image6: e.target.files[0],
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-row gap-2">
                <div className="flex w-1/2">
                  <div className="flex flex-row gap-2">
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Langkah 7</label>
                        <input
                          type="text"
                          value={formDataPanduan.step7}
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              step7: e.target.value,
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                          
                        />
                      </div>
                    </div>
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Gambar 7</label>
                        <input
                          type="file"
                          name="image7"
                          accept="*"
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              image7: e.target.files[0],
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex w-1/2">
                  <div className="flex flex-row gap-2">
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Langkah 8</label>
                        <input
                          type="text"
                          value={formDataPanduan.step8}
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              step8: e.target.value,
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                          
                        />
                      </div>
                    </div>
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Gambar 8</label>
                        <input
                          type="file"
                          name="image8"
                          accept="*"
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              image8: e.target.files[0],
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-row gap-2">
                <div className="flex w-1/2">
                  <div className="flex flex-row gap-2">
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Langkah 9</label>
                        <input
                          type="text"
                          value={formDataPanduan.step9}
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              step9: e.target.value,
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                          
                        />
                      </div>
                    </div>
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Gambar 9</label>
                        <input
                          type="file"
                          name="image9"
                          accept="*"
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              image9: e.target.files[0],
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex w-1/2">
                  <div className="flex flex-row gap-2">
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Langkah 10</label>
                        <input
                          type="text"
                          value={formDataPanduan.step10}
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              step10: e.target.value,
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                          
                        />
                      </div>
                    </div>
                    <div className="flex w-1/2">
                      <div>
                        <label className="block font-medium mb-1">Gambar 10</label>
                        <input
                          type="file"
                          name="image10"
                          accept="*"
                          onChange={(e) =>
                            setFormDataPanduan({
                              ...formDataPanduan,
                              image10: e.target.files[0],
                            })
                          }
                          className="w-full border border-gray-300 p-2 rounded-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <span className='text-sm text-red-600'><i>*recommended file type: .png</i></span>

              {/* Buttons */}
              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-200 rounded-full hover:bg-gray-300 transition"
                  onClick={() => {
                    setAddPanduan(null);
                    setEditId(null);
                  }}
                >
                  Batal
                </button>

                <button
                  type="submit"
                  className="px-6 py-2 rounded-full bg-gradient-to-r from-blue-600 to-red-600 text-white hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                >
                  {editId ? "Update" : "Simpan"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Panduan;
